import React, { useMemo } from "react";
import { Box } from "@mui/material";
import StateOfUseDrillDownTable from "./ChartDrillDown/StateOfUseDrillDownTable";
import {
  STATE_OF_USE_LEVEL2_COLUMNS_CONFIG,
  STATE_OF_USE_LEVEL2_COLUMN_ORDER,
  getStateOfUseTrendLevel2Data,
} from "./ChartDrillDown/ChartDrillDownTable";
import TextWithCopy from "../../../Features/Table/GenericDraggableTable/Renderers/columnTypes/TextWithCopy";

// ─── Vehicle-license-plate renderer (same as in the drill-down modal) ──────────
const customRenderers = {
  "vehicle-license-plate": (record) => {
    const isActive = record?.status === "active";
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            flexShrink: 0,
            backgroundColor: isActive ? "#2DB55D" : "#9E9E9E",
          }}
        />
        <TextWithCopy
          text={record?.licensePlateNumber}
          type="Bus Number"
          textStyle={{ color: "#6D72F6" }}
        />
      </Box>
    );
  },
};

// ─── Table config for the vehicle list in details page ────────────────────────
const TABLE_CONFIG = {
  title: () => "Vehicle List",
  tableColumnsConfig: STATE_OF_USE_LEVEL2_COLUMNS_CONFIG,
  tableColumnOrder: STATE_OF_USE_LEVEL2_COLUMN_ORDER,
  emptyMessage: "No vehicles found",
};

const StateOfUseTrendDetailsTableSection = ({ startDate, endDate, hierarchicalLocation, isOpen }) => {
  return (
    <StateOfUseDrillDownTable
      tableConfigs={TABLE_CONFIG}
      getTableData={getStateOfUseTrendLevel2Data}
      selectedDataPoint={null}
      customRenderers={customRenderers}
      showColumnSettings={true}
      isOpen={isOpen}
    />
  );
};

export default StateOfUseTrendDetailsTableSection;
